import React from 'react';
import { Flex, Text, Box } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const data = useStaticQuery(graphql`
    query {
      theEnd: file(relativePath: { eq: "theEnd.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      letterOfWinMag: file(relativePath: { eq: "letterOfWinMag.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }`
  );
  return (
    <Flex flexDirection='row'>
      <Box width={['20vw', '0vw']}/>
      <Flex
        flexDirection='column'
        width={'80vw', '100vw'}
        justifyContent='center'
         alignItems='center'
         color='#CBCFD4'>
        <h2> The Full Narrative</h2>
        <Box><Text>Whose grounds these are, I think I know</Text></Box>
        <Box><Text>His home is in the North Pole though</Text></Box>
        <Text>He will not mind me traipsing here</Text>
        <Text mb={2}>To watch his students learn and grow</Text>
        <Text>Some other folk might stop and sneer</Text>
        <Text>"Two turtle doves, this man did rear?"</Text>
        <Text>I'll find the birds, come push or shove</Text>
        <Text mb={2}>Objectives given: I'll soon clear</Text>
        <Text>Upon discov'ring each white dove,</Text>
        <Text>The subject of much campus love,</Text>
        <Text>I find the challenges are more</Text>
        <Text mb={2}>Than one can count on woolen glove.</Text>
        <Text>Who wandered thus through closet door?</Text>
        <Text>Ho ho, what's this? What strange boudoir!</Text>
        <Text>Things here cannot be what they seem</Text>
        <Text mb={2}>That portal's more than clothing store.</Text>
        <Text>Who enters contests by the ream</Text>
        <Text>And lives in tunnels meant for steam?</Text>
        <Text>This Krampus bloke seems rather strange</Text>
        <Text mb={2}>And yet I must now join his team...</Text>
        <Text>Despite this fellow's funk and mange</Text>
        <Text>My fate, I think, he's bound to change.</Text>
        <Text>What is this contest all about?</Text>
        <Text mb={2}>His victory I shall arrange!</Text>
        <Text>To arms, my friends! Do scream and shout!</Text>
        <Text>Some villain targets Santa's route!</Text>
        <Text>What scum - what filth would seek to end</Text>
        <Text mb={2}>Kris Kringle's journey while he's out?</Text>
        <Text>Surprised, I am, but "shock" may tend</Text>
        <Text>To overstate and condescend.</Text>
        <Text>'Tis little more than plot reveal</Text>
        <Text mb={2}>That fairies often do extend</Text>
        <Text>And yet, despite her jealous zeal,</Text>
        <Text>My skills did win, my hacking heal!</Text>
        <Text>No dental dealer can so keep</Text>
        <Text mb={2}>Our red-clad hero in ordeal!</Text>
        <Text>This Christmas must now fall asleep,</Text>
        <Text>But next year comes, and troubles creep.</Text>
        <Text>And Jack Frost hasn't made a peep,</Text>
        <Text mb={5}>And Jack Frost hasn't made a peep...</Text>

        <h2>The final scene:</h2>
        <Img fluid={data.theEnd.childImageSharp.fluid}
                style={{ margin: 0,  maxHeight: '80vh', width: '80vw' }}
                imgStyle={{ objectFit: 'contain' }}
        />
        <Text my={2}>There's a piece of paper in the left corner. It's a "Cliff Hanger"... </Text>
        <Img fluid={data.letterOfWinMag.childImageSharp.fluid}
                style={{ margin: 0,  maxHeight: '80vh', width: '80vw' }}
                imgStyle={{ objectFit: 'contain' }}
        />
        <div height="60px"/>
      </Flex>
    </Flex>
  );
}
